(function ($) {
    $.extend($.mediaComponent.messages, {
        actions: {
            delete: "Supprimer le média"
        }
    });
})(jQuery);
